// extracted by mini-css-extract-plugin
export default {"page":"w1-z","cartModal":"x1-z","checkout":"y1-z","placeholder":"z1-z","account":"A1-z"};